module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$store.state.user.settings) ? _c('div', {
    staticStyle: {
      "height": "90%"
    },
    attrs: {
      "id": "check-in"
    }
  }, [_c('mu-flexbox', {
    staticStyle: {
      "height": "90%"
    },
    attrs: {
      "justify": "center",
      "align": "center"
    }
  }, [_c('mu-flexbox-item', {
    staticClass: "white content"
  }, [_c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "10",
      "desktop": "10"
    }
  }), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "80",
      "desktop": "80"
    }
  }, [_c('router-view')], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "10",
      "desktop": "10"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('mu-flexbox', {
    staticClass: "navigation"
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [(_vm.status.isDiabetic) ? _c('div', [_c('div', {
    staticClass: "oval left",
    class: {
      active: _vm.$route.name === 'WeightCheckin'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "oval left",
    class: {
      active: _vm.$route.name === 'Hba1cCheckin'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "oval",
    class: {
      active: _vm.$route.name === 'GoalsCheckin'
    }
  })]) : _c('div', [_c('div', {
    staticClass: "oval",
    class: {
      active: _vm.$route.name === 'WeightCheckin'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "oval left",
    class: {
      active: _vm.$route.name === 'GoalsCheckin'
    }
  })])])], 1), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "content"
  }, [(_vm.$route.name === 'WeightCheckin') ? _c('mu-flat-button', {
    staticClass: "transparent",
    attrs: {
      "label": "Skip"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.determineRoute()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.$route.name === 'Hba1cCheckin') ? _c('mu-flat-button', {
    staticClass: "transparent",
    attrs: {
      "label": "I don't know my HbA1c"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.navigate('GoalsCheckin')
      }
    }
  }) : _vm._e()], 1)])], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2b729798","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/CheckIn/Layout.vue
// module id = 3656
// module chunks = 1